import * as React from 'react';
import {useRef} from 'react'
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import blueGrey from '@material-ui/core/colors/blueGrey';
import Container from '@material-ui/core/Container';

const useStyles = makeStyles((theme) => ({
  offset: {
    height: 200,
    marginBottom: 10,
    [theme.breakpoints.down('xs')]: {
      minHeight: 120,
    },
  },
  root: {
    paddingTop: 10,
    color: theme.palette.common.white,
    height: 200,
    width: '100%',
    position: 'absolute',
    left: 0,
    top: 0,
    backgroundPosition: 'left bottom',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundColor: blueGrey[800],
    textShadow: '1px 1px 2px rgba(50, 50, 50, 0.7)',
    '& h1': {
      marginTop: 40,
      marginLeft: 30,
      textAlign: 'left',
    },
    '& h2': {
      textAlign: 'left',
      marginLeft: 30,
    },
    '& img': {
      maxWidth: '100%',
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    [theme.breakpoints.down('sm')]: {
      '& h2, & h1': {
        paddingLeft: 10,
        textAlign: 'center',
      },
    },
    [theme.breakpoints.down('xs')]: {
      '& h1': {
        marginTop: 10,
      },
      minHeight: 120,
      height: 'auto',
      '& img': {
        maxHeight: '80px',
      }
    }
  },
}));

export default function EventHeader(props) {
  const classes = useStyles();
  const headerRef = useRef(null);
  return (<>
    <div className={classes.offset} style={{ height: (headerRef.current ? headerRef.current.clientHeight : 'auto') }}></div>
    <div ref={headerRef} className={classes.root} style={ props.headerURL ? {backgroundImage: `url(${props.headerURL})` } : {} }>
      <Container>
        <Grid container>
          <Grid item sm={3} xs={12} style={{textAlign: 'center'}}>
            { props.logoURL ?
            <img src={props.logoURL.toString()} alt='Logo' style={{visibility: (props.logoURL ? 'visible' : 'hidden')}} />
            : '' }
          </Grid>
          <Grid item sm={9} xs={12}>
            <Typography variant="h1" display="block" gutterBottom>{props.eventTitle}</Typography>
            <Typography variant="h2" display="block" gutterBottom>{props.eventSubtitle}</Typography>
          </Grid>
        </Grid>
      </Container>
  </div></>);
}
